import { Spinner } from "@chakra-ui/react";
import * as React from "react";

export const Loader = () => {
  return <Spinner thickness='4px' speed='0.8s' emptyColor='gray.200' color='blue.500' size='lg' />;
};
